import React from 'react'

const Explorebox = (props) => {

  const eventHandler=(value)=>{
      const container=document.getElementById('explore-container');
      console.log(container)
    //   const transNum=Number(value);
      container.style.transform=`translate(${value})`;
  }
    return (
        <>
          <div className="explore__header">
              <ul>
                  <li><a href="#" onClick={()=>eventHandler('0%')}>Details</a></li>
                 
                  <li><a href="#" onClick={()=>eventHandler('-33.33%')}>Rules</a></li>
                  <li><a href="#" onClick={()=>eventHandler('-66.33%')}>Contact Us</a></li>
              </ul>
              </div>  

             <div className="explore__big-container">
             <div className="explore__container" id='explore-container'>
                  <div className="tab_content one"  id='details'>
                       <div className="div1">
                           <h3>{props.name} :</h3>
                           <p>{props.date}</p>
                       </div>
                       <div className="div2">
                           <h3>Duration</h3>
                           <p>{props.duration}</p>
                       </div>
                       <div className="div3">
                           <h3>Mode</h3>
                           <p>Live classroom</p>
                       </div>
                  </div>
                  {/* tab */}
                  <div className="tab_content two" id='rules'>
                          <div className="div1">
                              <h3>Eligibility : <span>{props.eligibility} </span></h3>
                              <h3>Payment Instructions : <span>{props.payment}</span></h3>
                              <h3>Prerequisites : <span>{props.prerequisites}</span></h3>
                              <h3>Certificate Criterion : <span>{props.certificate} </span></h3>
                              <h5> {props.note} </h5>
                          </div>
                  </div>
                  {/* tab */}
                  <div className="tab_content three">
                      <h2> {props.person} </h2>
                      <h4> {props.mail} </h4>
                      <p>contact: {props.contact} </p>
                  </div>
              </div>
             </div>
        </>
    )
}

export default Explorebox
